<template>
  <div class="tw-flex tw-items-center tw-gap-3">
    <slot />
  </div>
</template>
